import SmaConfigurator from "./components/SmaConfigurator";


export default SmaConfigurator;